export const setSongsSelected = (current, songs, checked) => {
  const ids = new Set(songs.map((song) => song.id));
  if (!checked) return current.filter((song) => !ids.has(song.id));

  const existing = new Set(current.map((song) => song.id));
  const additions = [];
  songs.forEach((song) => {
    if (!existing.has(song.id)) {
      existing.add(song.id);
      additions.push(song);
    }
  });
  return [...current, ...additions];
};
